import React from 'react'

// Reactor UI
import { Box, Flex } from 'reactor-ui'

import SidebarUser from './SidebarUser'
import SidebarTenant from './SidebarTenant'
import useLayoutConfig from 'reactor-vera/hooks/useLayoutConfig'


const SidebarFooter = props => {
  const [layoutConfig, updateLayoutConfig] = useLayoutConfig()
  const isExtended = layoutConfig?.sidebar?.extended
  return (
    <Flex sx={{
      transition: 'all 0.2s ease',
      height: isExtended ? '50px' : '70px',
      bottom: 0,
      position: 'fixed',
      width: isExtended ? 240 : 90,
      bg: 'dark.900',
      mx: -3,
      px: 3,
      py: isExtended ? 0 : 3,
      color: 'light.500',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: isExtended ? 'row' : 'column'
    }}>
      <SidebarUser/>
      <SidebarTenant/>
    </Flex>
  )
}

export default SidebarFooter